"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var ordered_1 = require("utils/selectors/ordered");
var single_1 = require("utils/selectors/single");
var AddUsers_1 = __importDefault(require("./AddUsers"));
var PreviewUserTeam_1 = __importDefault(require("./PreviewUserTeam"));
var InviteUsers = function () {
    var myTeam = (0, react_redux_1.useSelector)(single_1.selectMyCompanyTeam);
    var _a = __read((0, react_1.useState)(myTeam === null || myTeam === void 0 ? void 0 : myTeam.id), 2), currentTeamId = _a[0], setCurrentTeamId = _a[1];
    var companyTeams = (0, react_redux_1.useSelector)(ordered_1.selectCompanyTeams);
    if (!(0, react_redux_firebase_1.isLoaded)(companyTeams)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var currentTeam = companyTeams.find(function (cT) { return cT.id === currentTeamId; });
    return ((0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: function () { return undefined; }, initialValues: { memberEmails: [] }, keepDirtyOnReinitialize: true }, { children: function () { return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, sx: { height: '100%' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, sm: 12, md: 5, item: true }, { children: (0, jsx_runtime_1.jsx)(AddUsers_1.default, { team: currentTeam, setTeamId: setCurrentTeamId }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ md: 7, item: true, height: "100%", bgcolor: "green.main" }, { children: (0, jsx_runtime_1.jsx)(PreviewUserTeam_1.default, { userTeam: currentTeam }) }))] }))); } })));
};
exports.default = InviteUsers;
